import React, { Component } from "react";
import { FormGroup, Row, Col, FormControl, Form} from "react-bootstrap";
import "react-day-picker/lib/style.css";
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class EventTypeForm extends Component {
  constructor(prop) {
    super(prop);
    this.state = {
      selectSearchCategory: {
        value: this.props.eventType,
      },
    };
  }
   
  // 画面描写が終わった後に値を取得。
  componentDidMount() {
    if(this.props.eventType === "1"){
      document.getElementById("EventSelectType").classList.add("hard-acceleration")
    }
    else if(this.props.eventType === "2"){
      document.getElementById("EventSelectType").classList.add("harsh-braking")
    }
    else if(this.props.eventType === "3"){
      document.getElementById("EventSelectType").classList.add("cornering")
    }
  }

  handleTypeSelect = () => {
    this.props.selectEventType(this.selectSearchCategory.value);
  };

  render() {
    const {t} = this.props;

    return (
      <div className="selectSafetyMap">
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Form horizontal>
              <Col md={12} sm={12} xs={12}>
                <FormGroup>
                  <FormControl
                    className="eventSelect"
                    id = "EventSelectType"
                    componentClass="select"
                    defaultValue={this.props.eventType}
                    onChange={this.handleTypeSelect.bind(this)}
                    placeholder="select"
                    inputRef={(ref) => {
                      this.selectSearchCategory = ref;
                    }}
                  >
                    <option value="2">{t('Common.HarshBraking')}</option>
                    <option value="1">{t('Common.HardAcceleration')}</option>
                    <option value="3">{t('Common.HarshCornering')}</option>
                  </FormControl>
                </FormGroup>
              </Col>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withTranslation()(EventTypeForm);



// WEBPACK FOOTER //
// ./src/component/SafetyMap/EventTypeForm.js